import React from 'react';
import './TopTraded.css'
import { useTranslation } from "react-i18next";
import * as Colors from '../../../constants/Colors';

const TopTraded = () => {
    const { i18n } = useTranslation();
    return (
        <>
            <ul className='list-TopTraded-container'>
                <li className='item-TopTraded'>
                    <a className="part-1" href="" >
                        <span className="image-container image-overlay" style={{ backgroundColor: "rgb(115, 191, 255)" }}>
                            <img src="" alt="logo" />
                        </span>
                        <span className="info">
                            <span className="name-main ets-bold ng-star-inserted" > TABREED </span>
                            <span className="name-sub ng-star-inserted" > NATIONAL CENTRAL COOLING COMPANY </span>
                        </span>
                    </a>
                    <span className="part-2">
                        <button
                            className="Buy-Sell-button  ml-auto mr-auto mt-2"
                            type="button"
                            style={{
                                backgroundColor: Colors.BackgroundBuyBtn,
                            }}
                        >
                            {i18n.t("buy") + " 320.15 "}
                        </button>
                    </span>
                    <span className="part-3">
                        <button
                            className="Buy-Sell-button  ml-auto mr-auto mt-2"
                            type="button"
                            style={{
                                backgroundColor: Colors.BackgroundSellBtn,
                            }}
                        >
                            {i18n.t("sell") + " 27.15 "}
                        </button>
                    </span>
                </li>
                <li className='item-TopTraded'>
                    <a className="part-1" href="" >
                        <span className="image-container image-overlay" style={{ backgroundColor: "rgb(115, 191, 255)" }}>
                            <img src="" alt="logo" />
                        </span>
                        <span className="info">
                            <span className="name-main ets-bold ng-star-inserted" > AGLTY </span>
                            <span className="name-sub ng-star-inserted" > AGILITY PUBLIC WAREHOUSING  COMPANY (K.S.C.) </span>
                        </span>
                    </a>
                    <span className="part-2">
                        <button
                            className="Buy-Sell-button  ml-auto mr-auto mt-2"
                            type="button"
                            style={{
                                backgroundColor: Colors.BackgroundBuyBtn,
                            }}
                        >
                            {i18n.t("buy") + " 135.9 "}
                        </button>
                    </span>
                    <span className="part-3">
                        <button
                            className="Buy-Sell-button  ml-auto mr-auto mt-2"
                            type="button"
                            style={{
                                backgroundColor: Colors.BackgroundSellBtn,
                            }}
                        >
                            {i18n.t("sell") + " 30.10 "}
                        </button>
                    </span>
                </li>
                <li className='item-TopTraded'>
                    <a className="part-1" href="" >
                        <span className="image-container image-overlay" style={{ backgroundColor: "rgb(115, 191, 255)" }}>
                            <img src="" alt="logo" />
                        </span>
                        <span className="info">
                            <span className="name-main ets-bold ng-star-inserted" > EMAAR </span>
                            <span className="name-sub ng-star-inserted" > EMAAR PROPERTIES PJSC  </span>
                        </span>
                    </a>
                    <span className="part-2">
                        <button
                            className="Buy-Sell-button  ml-auto mr-auto mt-2"
                            type="button"
                            style={{
                                backgroundColor: Colors.BackgroundBuyBtn,
                            }}
                        >
                            {i18n.t("buy") + " 36.20 "}
                        </button>
                    </span>
                    <span className="part-3">
                        <button
                            className="Buy-Sell-button  ml-auto mr-auto mt-2"
                            type="button"
                            style={{
                                backgroundColor: Colors.BackgroundSellBtn,
                            }}
                        >
                            {i18n.t("sell") + " 14.15 "}
                        </button>
                    </span>
                </li>
            </ul>
        </>
    );
};

export default TopTraded;


